import * as React from 'react';
import TextfieldUnit from '../../../../../../components/TextfieldUnit';

//REDUX
import ACTIONS from '../../../../../../../redux/action';
import { useSelector, useDispatch } from 'react-redux';

const ExtraFeeInputs = ({ ...props }) => {
	const [inputError, setInputError] = React.useState({});
	const isMobile = window.innerWidth < 480;
	const dispatch = useDispatch();
	const accountingPrice = useSelector(
		(state) => state.provider_acc_monthly_price
	);
	const handleChange = (event, storeObj) => {
		let value = event.target.value;
		dispatch(
			ACTIONS.addProviderInfo({
				id: event.target.id,
				data: value,
				stateObject: storeObj,
			})
		);
	};
	return (
		<div
			style={{
				display: 'grid',
				gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)',
				gap: '16px',
				width: '100%',
			}}>
			{/* <span className={classes.profileTitle}>{props.title}</span> */}
			{props.dataText.map((item, i) => {
				//console.log(props.dataText, 'props.dataText');
				return (
					<div key={i}>
						<TextfieldUnit
							unit={props.unit || 'Eur'}
							id={item.id}
							variant='outlined'
							type='text'
							value={accountingPrice[item.id]}
							title={item.label}
							onChange={(event) => {
								handleChange(event, 'provider_acc_monthly_price');
								// if (
								// 	(event.target.value && inputError[item.id]) ||
								// 	(event.target.value === 0 && inputError[item.id])
								// ) {
								// 	setInputError({
								// 		...inputError,
								// 		[item.id]: false,
								// 	});
								// }
							}}
							// error={inputError[item.id]}
							// onBlur={(event) => {
							// 	if (!event.target.value) {
							// 		setInputError({ ...inputError, [item.id]: true });
							// 	}
							// }}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default ExtraFeeInputs;
